<template>
	<div class="container">
			<div>
				<h2>Api requests</h2>
				<hr>
				<b-row class="filterwws">
					<b-form-group class="col-md-3" label="ID:">
						<b-form-input  v-model="filters.requestId" />
					</b-form-group>
					<b-form-group class="col-md-3" label="Fecha Inicio">
						<b-form-datepicker
								locale="es"
								reset-button
								v-model="filters.startDate"
						/>
					</b-form-group>

					<b-form-group class="col-md-3" label="Fecha fin">
						<b-form-datepicker
								locale="es"
								reset-button
								v-model="filters.endDate"
						/>
					</b-form-group>

				</b-row>
				<b-row>
					<b-form-group class="col-10" >
						<template #label>
							Keyword:<md-icon icon="info" v-b-tooltip.hover title="Try this: ?url=quote-request&search=cun|hotel" />
						</template>
						<b-form-input  v-model="filters.keyword" />
					</b-form-group>
					<b-form-group class="col-2" label=".">
						<b-button type="button" variant="primary" @click="search">Buscar</b-button>
					</b-form-group>
				</b-row>

                <AjaxTable
					permission-show="changelog.show"
					id="apilogs-index-list"
					:filters="filtersClean"
					:columns="modelColumns"
					resource="api-activities"
					responsive='md'
				>
                    <template #cell(show)="row">
                        <b-button @click="fnRequestSelected(row)"   variant="outline-primary">Show</b-button>
                    </template>
                     <template #cell(httpCodeResponse)="row">
                        <b-badge :variant="getVariantHttpCode(row.item.httpCodeResponse)"> {{row.item.httpCodeResponse}}</b-badge>
                    </template>
                     <template #cell(created_at)="row">
                        {{dateTimeToLocal(row.item.created_at)}}
                    </template>
					<template #cell(offers)="row">
						<span v-if="totalOffers(row)>0">
							Si <b-badge variant="primary">{{totalOffers(row)}}</b-badge>
						</span>
                    </template>
				</AjaxTable>


                <!-- The modal -->
                <b-modal ref="my-modal-api-request" size="lg">
                    <section v-if="this.requestSelected">
                        <b-row>
                            <b-col>
                                <b-button :variant="getVariantHttpCode(requestSelected.httpCodeResponse)">
                                {{requestSelected.httpCodeResponse}}
                                </b-button>
                                <span>[<b>{{requestSelected.httpMethod}}</b>] {{requestSelected.fullUrl}}</span>
                            </b-col>
                        </b-row>
                        <div class="alert alert-secondary mt-4">
                            <pre>{{requestClean}}</pre>
                        </div>

                        <section class="mt-4" v-if="requestSelected.debug">
                            <h5 >Exception</h5>
                            <div class="alert alert-warning" style="font-size:small;font-weight:bold">
                                <pre>{{requestSelected.debug}}</pre>
                            </div>

                         </section>

                    </section>
                </b-modal>
			</div>
			<hr>
		</div>
</template>

<script>
import AjaxTable from '../../helpers/AjaxTable.vue'
 import moment from 'moment'

export default {
	components: {AjaxTable},
	data(){
		return {
			filters : {
				requestId: '',
				startDate:'',
				endDate:'',
				keyword:''
			},
			modelColumns : [
                {key:"requestId",label:"requestId"},
				{key:"api_key_data.point_of_sale.domain",label:"POS"},
				{key: 'created_at',	label: 'Created At'},
				{key: 'fullUrl',    label: 'Url'},
                {key: 'httpCodeResponse', label: 'Code'},
				{key:'offers',label:'Precios?'},
                {key: 'show',    label: 'show'}

			],
            requestSelected:null
		}
	},
	methods: {
		search(){
			this.$root.$emit('bv::refresh::table', 'apilogs-index-list')
		},
        fnRequestSelected(row){
            this.requestSelected= row.item;
            this.$refs["my-modal-api-request"].show();
        },
        getVariantHttpCode(code){
            if(code==200){
                return "success";
            }else{
                return "danger";
            }

        },
        dateTimeToLocal(date){
            return moment(date).format("YYYY-MM-DD HH:mm")
        },
		totalOffers(row){
			try{
				let dataParsed = JSON.parse(row.item.response);
				return (dataParsed.data.offers.length)
			}catch(err){
				return 0;
			}
		}
	},
	computed:{
		filtersClean(){
			return {
				requestId:this.filters.requestId,
				startDate:this.filters.startDate,
				endDate:this.filters.endDate,
				keyword:this.filters.keyword,
			}
		},
        requestClean(){
            if(this.requestSelected){
                let formated =  {
                    apikey          : this.requestSelected.apiKey,
                    input           : JSON.parse(this.requestSelected.input),
                    response        : JSON.parse(this.requestSelected.response),
                }
                return formated
            }
            return null;

		}

	},
	mounted() {

	}
}
</script>

<style>

</style>
